import Modal from 'antd/lib/modal';
import React, { ReactElement, cloneElement, useState, useRef, HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { Button, Checkbox, Space } from 'antd';
import { useTranslate } from '@tolgee/react';
import { useTransAppProductName } from 'hooks/useTrans';
import { goPlatformServiceNoRemind2Cache } from 'services/cache';

const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
`;

export interface SellerCenterProps {
  platform: General.PlatformUpperCaseTunnel;
  children: ReactElement<HTMLAttributes<Element>>;
}

function SellerCenter(props: SellerCenterProps) {
  const { platform, children } = props;

  const { t } = useTranslate();
  const appProductNameT = useTransAppProductName();

  const [visible, setVisible] = useState(false);

  const noRemind = useRef(!!goPlatformServiceNoRemind2Cache.get());

  if (platform === 'LAZADA' || platform === 'TOKOPEDIA') {
    return children;
  }

  return (
    <>
      {cloneElement(children, {
        ...children.props,
        onClick: (e: React.MouseEvent) => {
          if (children.props.onClick) {
            children.props.onClick(e);
          }
        },
      })}
      <Modal
        title={t('sider.风险提示')}
        visible={visible && !goPlatformServiceNoRemind2Cache.get()}
        onCancel={() => setVisible(false)}
        footer={
          <ModalFooter>
            <Checkbox
              onChange={(e) => {
                noRemind.current = e.target.checked;
              }}
            >
              {t('sider.不再提醒')}
            </Checkbox>
            <Space>
              <Button onClick={() => setVisible(false)}>{t('sider.取消')}</Button>
              <Button
                type="primary"
                onClick={(e) => {
                  if (noRemind.current) {
                    goPlatformServiceNoRemind2Cache.set('1');
                  } else {
                    goPlatformServiceNoRemind2Cache.remove();
                  }
                  setVisible(false);

                  if (children.props.onClick) {
                    children.props.onClick(e);
                  }
                }}
              >
                {t('sider.确定')}
              </Button>
            </Space>
          </ModalFooter>
        }
        width={480}
      >
        {appProductNameT('sider.leaveToSellerCenterWarning')}
      </Modal>
    </>
  );
}

export default SellerCenter;
